export default __webpack_public_path__ + "57672bdee193a09fe174bfdd8cb04f55.svg";